import springIcon from "../svgs/spring-boot.svg"
import ansible from "../svgs/ansible.svg"
import python from "../svgs/python.svg"
import java from "../svgs/java.svg"
import nodejs from "../svgs/nodejs.svg"
import reactjs from "../svgs/react-js.svg"
import azure from "../svgs/azure.svg";
import devops from "../svgs/dev-ops.svg"
import docker from "../svgs/docker.svg"
import git from "../svgs/git.svg"
import html from "../svgs/html.svg"
import mongodb from "../svgs/mongodb.svg"
import mysql from "../svgs/mysql.svg"
import nextjs from "../svgs/next-js.svg"
import js from "../svgs/js.svg"
import restapi from "../svgs/rest-api.svg"
import tailwind from "../svgs/tailwind.svg"
import kubernetes from "../svgs/kubernetes.svg"

 const skills = [
    { name: "Spring Boot", src: springIcon },
    { name: "Python", src:python},
    { name: "Java", src:java},
    { name: "Node.js", src:nodejs},
    { name: "React.js", src:reactjs},
    { name: "Docker", src:docker},
    { name: "MongoDb", src:mongodb},
    { name: "MySql", src:mysql},
    { name: "Next.js", src:nextjs},
    { name: "Java Script", src:js},
    { name: "REST Api", src:restapi},
    { name: "Html/CSS", src:html},
    { name: "Tailwind", src:tailwind},
    { name: "Kubernetes", src:kubernetes},
    { name: "Ansible", src:ansible},
    { name: "Azure", src:azure},
    { name: "Devops", src:devops},
    { name: "Git", src:git},




    
]
export default skills;
